/**
 * Report given to check compliance of planning operation vs the Operation Customer planning settings
 */
export class MissionPlanningComplianceReport {
    planningCompliance: boolean = true;
    complianceInfringements: Array<string> = [];
    compliancWarnings: Array<string> = [];
    notCompliantActivity: Array<boolean> = [];
    
    concatMessages(report: MissionPlanningComplianceReport){   
    
        if(!report.planningCompliance){
            this.planningCompliance = false;
        }
         
        if(report.complianceInfringements.length > 0){
            report.complianceInfringements.forEach(m => {
                if(this.complianceInfringements.indexOf(m) === -1){
                    this.complianceInfringements.push(m);
                }
            });            
        }
        if(report.compliancWarnings.length > 0){
            report.compliancWarnings.forEach(m => {
                if(this.compliancWarnings.indexOf(m) === -1){
                    this.compliancWarnings.push(m);
                }
            });
        }
    }
}
